import { Icon, IconProps } from '@chakra-ui/react';

export const FacebookIcon: React.FC<IconProps> = props => (
  <Icon
    aria-label="facebook icon"
    data-testid="facebook-icon"
    width="24px"
    height="24px"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M21.9996 12C21.9996 6.47721 17.5225 2 11.9998 2C6.47711 2 2 6.47721 2 12C2 16.6896 5.22874 20.6249 9.58425 21.7057V15.056H7.52229V12H9.58425V10.6832C9.58425 7.27961 11.1246 5.70201 14.4662 5.70201C15.0997 5.70201 16.1929 5.82641 16.6401 5.95041V8.72042C16.4041 8.69562 15.9941 8.68322 15.4849 8.68322C13.8454 8.68322 13.2118 9.30442 13.2118 10.9192V12H16.4781L15.9169 15.056H13.2118V21.9269C18.1633 21.3289 22 17.1128 22 12H21.9996Z"
      fill="#0866FF"
    />
    <path
      d="M15.9166 15.0559L16.4778 11.9999H13.2115V10.9191C13.2115 9.30431 13.845 8.68311 15.4846 8.68311C15.9938 8.68311 16.4038 8.69551 16.6398 8.72031V5.9503C16.1926 5.8259 15.0994 5.7019 14.4658 5.7019C11.1243 5.7019 9.58393 7.27951 9.58393 10.6831V11.9999H7.52197V15.0559H9.58393V21.7055C10.3575 21.8975 11.1667 21.9999 11.9995 21.9999C12.4095 21.9999 12.8139 21.9747 13.2111 21.9267V15.0559H15.9162H15.9166Z"
      fill="white"
    />
  </Icon>
);
